
class CapViewRoute {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_route'
}

function create(config) {
  return new CapViewRoute(config)
}

export default {
  key,
  create,
}
